import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EntityEditForm } from "@/components/common/EntityEditForm";
import { useEntityEditForm } from "@/hooks/common/useEntityEditForm";
import { useTranslation } from "react-i18next";
import { CompanyCustomFieldsEditTab } from "./CompanyCustomFieldsEditTab";

interface CompanyEditTabsProps {
  company: any;
  isEditing: boolean;
  onChange: (field: string, value: string | string[]) => void;
  customFieldsConfig?: any[]; // Custom fields configuration for the organization
}

export const CompanyEditTabs: React.FC<CompanyEditTabsProps> = ({ 
  company, 
  isEditing, 
  onChange,
  customFieldsConfig = []
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('basic');

  const handleFieldChange = (field: string, value: string | string[]) => {
    onChange(field, value);
  };

  // Create form configuration for basic info tab (contains all fields)
  const basicFormProps = useEntityEditForm({
    entityType: 'company',
    entity: company,
    onChange: handleFieldChange,
    tabType: 'all'
  });

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="w-full flex flex-wrap gap-1 bg-gray-100 rounded-sm p-1">
          <TabsTrigger value="basic" className="flex-shrink-0 text-xs sm:text-sm">
            {t('companies.editTabs.basicInfo', 'Basic Info')}
          </TabsTrigger>
          {customFieldsConfig.length > 0 && (
            <TabsTrigger value="customFields" className="flex-shrink-0 text-xs sm:text-sm">
              {t('companies.customFields.title', 'Custom')}
            </TabsTrigger>
          )}
        </TabsList>
        
        <TabsContent value="basic" className="mt-6">
          <EntityEditForm
            {...basicFormProps}
            isEditing={isEditing}
            title=""
            showSkillsAtBottom={false}
            entity={company}
          />
        </TabsContent>
        
        {customFieldsConfig.length > 0 && (
          <TabsContent value="customFields" className="mt-6">
            <CompanyCustomFieldsEditTab
              company={company}
              onChange={handleFieldChange}
              isEditing={isEditing}
            />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}; 